import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { submitTerminalDiagnostic } from "./api";
import { diagnosticSnapshot } from "./terminalDiagnostics";

export function SendDiagnosticDialog({ open, pageView, onClose }:
  { open: boolean; pageView: string; onClose: () => void }) {
  const { t } = useTranslation();
  const [comment, setComment] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(false);
  const close = () => { setComment(""); setSent(false); setError(false); onClose(); };
  const send = async () => {
    setSending(true); setError(false);
    try {
      const snapshot = diagnosticSnapshot();
      await submitTerminalDiagnostic({ ...snapshot, comment: comment.trim(),
        pagePath: `${location.pathname}${location.search}`, pageView,
        source: "MANUAL", severity: "INFO", fingerprint: null });
      setSent(true);
    } catch { setError(true); }
    finally { setSending(false); }
  };
  return <Dialog open={open} onClose={close} fullWidth maxWidth="sm">
    <DialogTitle>{t("transverse.diagnostic.sendTitle")}</DialogTitle>
    <DialogContent>
      <Stack spacing={2} sx={{ pt: .5 }}>
        <Typography color="text.secondary">
          {t("transverse.diagnostic.sendInfo")}
        </Typography>
        <TextField multiline minRows={3} label={t("transverse.diagnostic.comment")}
          value={comment} inputProps={{ maxLength: 1000 }}
          onChange={(event) => setComment(event.target.value)} />
        {sent && <Alert severity="success">{t("transverse.diagnostic.sent")}</Alert>}
        {error && <Alert severity="error">{t("transverse.diagnostic.sendError")}</Alert>}
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={close}>{t(sent ? "common.actions.close" : "common.actions.cancel")}</Button>
      {!sent && <Button variant="contained" disabled={sending} onClick={() => void send()}>
        {t("transverse.diagnostic.send")}
      </Button>}
    </DialogActions>
  </Dialog>;
}
